import { format, toDate } from "@/utilities/date";

// Convert range picker value to table filter 'selectedKeys'
export const getSelectedKeys = (value, dateFormat) => {
  const startDate = format(value?.[0], dateFormat);
  const endDate = format(value?.[1], dateFormat);

  if (startDate && endDate) return [startDate, endDate];

  return [];
};

// Convert table filter 'selectedKeys' to range picker value
export const getRangerPickerValue = (selectedKeys) => {
  const [startKey, endKey] = selectedKeys;

  const startDate = startKey ? toDate(startKey) : null;
  const endDate = endKey ? toDate(endKey) : null;

  return [startDate, endDate];
};
